import e from "../managers/braze-instance.js";
export function removeSubscription(r) {
  e.rr() && e.removeSubscription(r);
}
